import { Typography } from "components/Typography";

function TermsAndCondition() {
  return (
    <div>
      <Typography variant="footerSmall">Terms and Conditions</Typography>
      <Typography variant="footerSmall">FAQ</Typography>
    </div>
  );
}

export default TermsAndCondition;
